module.exports = __webpack_public_path__ + "static/img/eisart-laden.294d1c9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/eisart-laden.jpg
// module id = nXR8
// module chunks = 0